import { render, staticRenderFns } from "./DocumentoProductos.vue?vue&type=template&id=6ebcfb32&scoped=true"
import script from "./DocumentoProductos.vue?vue&type=script&lang=js"
export * from "./DocumentoProductos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ebcfb32",
  null
  
)

export default component.exports